import { z } from 'zod';

// Per-addon presentation state (keyed by addonKey in orgInfo.addons).
// PRESENTATION ONLY — access is gated by the JWT capability, never by these fields.
export const addonStateSchema = z.looseObject({
	hasAccess: z.boolean(),
	accessSource: z.string().nullable(),
	addonStatus: z.string().nullable(),
	trialEndsAt: z.string().nullable(),
	trialUsed: z.boolean(),
	cancelAtPeriodEnd: z.boolean(),
});

export const orgInfoSchema = z.looseObject({
	id: z.string(),
	name: z.string(),
	plan: z.string(),
	createdAt: z.string(),
	seats: z.looseObject({
		seatsIncluded: z.number(),
		seatsUsed: z.number(),
	}),
	role: z.string(),
	// Generic per-org add-on state, keyed by addonKey (e.g. { crm: {...}, ai_assistant: {...} }).
	addons: z.record(z.string(), addonStateSchema),
});

export const orgMemberSchema = z.looseObject({
	userId: z.string(),
	email: z.string(),
	role: z.string(),
	companyUsed: z.number(),
	contactUsed: z.number(),
	companyLimit: z.number().nullable(),
	contactLimit: z.number().nullable(),
});

export const orgInviteSchema = z.looseObject({
	id: z.string(),
	email: z.string().nullable(),
	role: z.string(),
	invitedAt: z.string(),
	expiresAt: z.string(),
	expired: z.boolean(),
});

const creditPoolSchema = z.looseObject({
	quota: z.number(),
	used: z.number(),
	held: z.number(),
	remaining: z.number(),
});

export const orgCreditsSchema = z.looseObject({
	pool: z.looseObject({ company: creditPoolSchema, contact: creditPoolSchema }),
	renewsAt: z.string().nullable(),
});

export const orgTeamSchema = z.looseObject({
	members: z.array(orgMemberSchema),
	invites: z.array(orgInviteSchema),
});
